import { animateScroll as scroll } from 'react-scroll'
import { StyledScrollBtn } from '@/components/styles'
import { useEffect, useState } from 'react'
import Icon from '@/assets/icons'
import { useMobileKeyboard } from '@/hooks'

export default function ScrollBtn() {
  const [visible, setVisible] = useState(false)
  const keyboardHidden = useMobileKeyboard()
  const shown = visible && !keyboardHidden

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY
      const windowHeight = window.innerHeight
      const documentHeight = document.body.offsetHeight

      const pageEnd = scrollPos + windowHeight >= documentHeight - 20
      const notPageEnd = scrollPos + windowHeight < documentHeight - 20
      const pageStart = scrollPos < 40

      if ((pageStart) && visible) {
        setVisible(false)
      }
      if (!pageStart && !visible) {
        setVisible(true)
      }
    }

    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [visible])

  useEffect(() => {
    const offsetVar = '--el-cta-offset'
    let barObserver
    let resizeObserver

    const apply = () => {
      const bar = document.getElementById('el-cta')
      const shown = bar && bar.classList.contains('on') && getComputedStyle(bar).display !== 'none'
      const height = shown ? Math.ceil(bar.getBoundingClientRect().height) : 0
      document.documentElement.style.setProperty(offsetVar, `${height}px`)
    }

    const watchBar = () => {
      barObserver?.disconnect()
      resizeObserver?.disconnect()
      const bar = document.getElementById('el-cta')
      if (!bar) {
        apply()
        return
      }
      barObserver = new MutationObserver(apply)
      barObserver.observe(bar, { attributes: true, attributeFilter: ['class', 'style'] })
      resizeObserver = new ResizeObserver(apply)
      resizeObserver.observe(bar)
      apply()
    }

    watchBar()
    const bodyObserver = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => [...mutation.addedNodes].some((node) => node.id === 'el-cta'))) {
        watchBar()
      }
    })
    bodyObserver.observe(document.body, { childList: true })

    return () => {
      bodyObserver.disconnect()
      barObserver?.disconnect()
      resizeObserver?.disconnect()
      document.documentElement.style.removeProperty(offsetVar)
    }
  }, [])

  return (
    <StyledScrollBtn
      onClick={() => scroll.scrollToTop()}
      visible={shown}
      aria-hidden={!shown || undefined}
      tabIndex={shown ? undefined : -1}
    >
      <Icon name="up-icon" />
    </StyledScrollBtn>
  )
}
